import { onMounted, onUnmounted } from 'vue';
import { useAppStore } from '@/stores';

export function useAppResize() {
	const appStore = useAppStore();
	const handleResize = () => appStore.setTableHeight();
	handleResize(); // Garante chamada imediata para ambiente de teste
	onMounted(() => {
		handleResize();
		window.addEventListener('resize', handleResize);
	});
	onUnmounted(() => {
		window.removeEventListener('resize', handleResize);
	});
}
